import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import './EscrowDetail.css';

const EscrowDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [escrow, setEscrow] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setEscrow({
        id: id,
        rfqId: 'RFQ-2024-102',
        vessel: 'MV Ocean Star',
        owner: 'Ocean Star Management',
        vendor: 'MarineTech Solutions',
        amount: 12500,
        currency: 'USD',
        status: 'in_progress',
        depositedDate: '2024-03-10',
        expectedRelease: '2024-03-25',
        actualRelease: null,
        platformFee: 625,
        vendorAmount: 11875,
        description: 'GMDSS Annual Survey - Payment held in escrow pending completion.',
        auditTrail: [
          { id: 1, action: 'Escrow Created', user: 'System', timestamp: '2024-03-10 09:00:00', details: 'Escrow created for RFQ-2024-102' },
          { id: 2, action: 'Payment Deposited', user: 'Ocean Star Management', timestamp: '2024-03-10 09:15:00', details: '$12,500 deposited into escrow' },
          { id: 3, action: 'Work Started', user: 'MarineTech Solutions', timestamp: '2024-03-12 08:30:00', details: 'Service work commenced' },
          { id: 4, action: 'Report Submitted', user: 'MarineTech Solutions', timestamp: '2024-03-20 14:00:00', details: 'Service report uploaded' },
          { id: 5, action: 'Pending Owner Approval', user: 'System', timestamp: '2024-03-20 14:05:00', details: 'Waiting for owner approval' }
        ]
      });
      setLoading(false);
    }, 500);
  }, [id]);

  const handleReleasePayment = () => {
    if (window.confirm('Are you sure you want to release this payment?')) {
      alert('Payment released successfully');
    }
  };

  const handleInitiateRefund = () => {
    if (window.confirm('Are you sure you want to initiate a refund?')) {
      alert('Refund initiated');
    }
  };

  if (loading) return <div className="loading-spinner">Loading escrow details...</div>;

  return (
    <div className="admin-escrow-detail">
      <button className="back-btn" onClick={() => navigate('/admin/payment-releases')}>
        <i className="fas fa-arrow-left"></i> Back to Payments
      </button>

      <div className="escrow-card">
        <div className="escrow-header">
          <h1>Escrow #{escrow.id}</h1>
          <div className="escrow-meta">
            <span className="escrow-id">RFQ: {escrow.rfqId}</span>
            <span className={`escrow-status ${escrow.status}`}>
              {escrow.status === 'in_progress' ? 'In Progress' : escrow.status}
            </span>
          </div>
        </div>

        <div className="escrow-body">
          <div className="info-grid">
            <div>
              <span className="label">Vessel</span>
              <span className="value">{escrow.vessel}</span>
            </div>
            <div>
              <span className="label">Owner</span>
              <span className="value">{escrow.owner}</span>
            </div>
            <div>
              <span className="label">Service Provider</span>
              <span className="value">{escrow.vendor}</span>
            </div>
            <div>
              <span className="label">Deposited Date</span>
              <span className="value">{escrow.depositedDate}</span>
            </div>
            <div>
              <span className="label">Expected Release</span>
              <span className="value">{escrow.expectedRelease}</span>
            </div>
            <div>
              <span className="label">Total Amount</span>
              <span className="value amount-highlight">${escrow.amount.toLocaleString()} {escrow.currency}</span>
            </div>
            <div>
              <span className="label">Platform Fee (5%)</span>
              <span className="value">${escrow.platformFee.toLocaleString()}</span>
            </div>
            <div>
              <span className="label">Vendor Amount</span>
              <span className="value">${escrow.vendorAmount.toLocaleString()}</span>
            </div>
          </div>

          <div className="audit-section">
            <h3><i className="fas fa-history"></i> Audit Trail</h3>
            <table className="audit-table">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {escrow.auditTrail.map(entry => (
                  <tr key={entry.id}>
                    <td>{entry.timestamp}</td>
                    <td>{entry.user}</td>
                    <td>{entry.action}</td>
                    <td>{entry.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="action-buttons">
            {escrow.status === 'in_progress' && (
              <Button variant="primary" onClick={handleReleasePayment} icon="fa-hand-holding-usd">
                Force Release Payment
              </Button>
            )}
            {escrow.status !== 'released' && (
              <Button variant="danger" onClick={handleInitiateRefund} icon="fa-undo">
                Initiate Refund
              </Button>
            )}
            <Button variant="secondary" icon="fa-download">
              Export Audit Log
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EscrowDetail;